<div class="dropdown-toggle-container" [class.dropdown-opened]="opened" [style.minWidth]="size">
  <span class="far fa-chevron-right dropdown-icon" [style.lineHeight]="size"></span>
</div>